module.exports = __webpack_public_path__ + "static/media/logo_fixmeeting.abf92d2f.png";